<template>
    <TextReading ref="textReading"
                 :article-detail="detailData"
                 :collect-handler="collect"
                 :collect-status="detailData.follow_state === '1'"
                 :chapter-change-handler="chapter"
                 :limit-id="limitId"
                 :has-print="true"
                 :qrcode-url="qrcodeUrl"
    >
        <div class="nav-wrap">
            <div class="subscribe-card-wrap">
                <div class="subscribe-card">
                    <div class="cover hb-resource-cover">
                        <img v-if="baseData"
                             :src="baseData.poster"
                        >
                    </div>
                    <div class="infos">
                        <h4 class="text2line">
                            {{ langTransfer(baseData.name) }}
                        </h4>
                        <div v-show="webInfo.isAllowLogin == '1' && baseData.name"
                             class="subscribe-btn-wrap lr-img-scale"
                             @click="addFocus"
                        >
                            <LottieAddBtn
                                :is-collection="baseData.follow_state === '1'"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="catelog-mask">
                <h5>{{ langTransfer('目录') }}</h5>
                <bscroll-view hide-scroll-bar :pull-up-handler="loadMore">
                    <div class="catelog-list">
                        <div v-for="(item, index) in menuList"
                             :key="index"
                             class="cate-item"
                             :style="{'font-weight': $route.params.id === item.id ? '' :'',
                                      color: $route.params.id === item.id ? '#303133' :''}"
                             @click="subCateClick(item.id)"
                        >
                            {{ langTransfer(item.title) }}
                        </div>
                    </div>
                </bscroll-view>
            </div>
        </div>
    </TextReading>
</template>
<script>
    import TextReading from '@/components/textReading'
    import LottieAddBtn from '@/components/lottieActions/add'
    import BscrollView from '@/components/bscrollView'
    import { resourceArticleDetail } from '@/api/lxc'
    import {
        detail,
        assemblyBookCatalogPageList,
        qrCode
    } from '../../api/lyl'

    export default {
        name: 'LevelFourCatalog',
        components: {
            TextReading,
            LottieAddBtn,
            BscrollView,
        },
        data () {
            return {
                baseData: {},
                detailData: {},
                getAll: false,
                menuList: [],
                limitId: {
                    start: '',
                    end: ''
                },
                currentId: '',
                qrcodeUrl: ''
            }
        },
        computed: {
            pageSetup () {
                return this.$store.state.pageSetup
            },
            user_unique_code () {
                return this.$store.state.user_unique_code
            },
            webInfo () {
                return this.$store.state.webInfo
            }
        },
        watch: {
            webInfo (newVal) {
                if (newVal.service_code) {
                    this.getBookDetail()
                    this.getCatalog()
                    this.getQrcode()
                    const { id } = this.$route.params
                    if (id) {
                        this.getArticle(id)
                    }
                }
            }
        },
        methods: {
            async getQrcode () {
                try {
                    const { resId: id } = this.$route.params
                    const data = await qrCode({
                        type: 3,
                        service_code: this.webInfo.service_code,
                        id,
                        user_unique_code: this.user_unique_code
                    })
                    this.qrcodeUrl = data
                } catch (err) {
                    console.log(err)
                }
            },
            addFocus () {
                const formData = {
                    type: 16,
                    res_code: this.$route.params.resId
                }
                const callback = (bool) => {
                    if (bool) {
                        this.baseData.follow_state = '2'
                    } else {
                        this.baseData.follow_state = '1'
                    }
                }
                this.$utils.userCollect(formData, callback)
            },
            chapter (isPrev) {
                const { menuList } = this
                const { id } = this.$route.params
                let newItem
                const currentIndex = menuList.findIndex((e) => {
                    return e.id === id
                })
                if (isPrev) {
                    newItem = menuList[currentIndex - 1]
                } else {
                    newItem = menuList[currentIndex + 1]
                }
                if (!newItem) {
                    return
                }
                this.subCateClick(newItem.id)
            },
            subCateClick (id) {
                this.$router.push({
                    params: {
                        id
                    }
                })
            },
            async getBookDetail () {
                try {
                    const { resId: id } = this.$route.params
                    const data = await detail({
                        service_code: this.webInfo.service_code,
                        type: '15',
                        id,
                        user_unique_code: this.user_unique_code
                    })
                    this.baseData = data
                } catch (err) {
                    console.log(err)
                }
            },
            loadMore (bscrollObj) {
                if (this.getAll) {
                    return
                }
                const newPage = Math.ceil(this.menuList.length / 15) + 1
                this.getCatelog(newPage, bscrollObj)
            },
            async getCatelog (page = 1, bscrollObj) {
                try {
                    const { resId: id } = this.$route.params
                    const { webInfo } = this
                    let { records: data } = await assemblyBookCatalogPageList({
                        service_code: webInfo.service_code,
                        id,
                        page,
                        pageSize: 15
                    })
                    const { readStatus } = this.webInfo
                    if (Number(readStatus) !== 2) {
                        data = data.slice(0, 3)
                        this.getAll = true
                    }
                    if (data.length < 15) {
                        this.getAll = true
                    }
                    if (page !== 1) {
                        this.menuList = this.menuList.concat(data)
                        this.setLimitId()
                        if (bscrollObj) {
                            bscrollObj.finishPullUp()
                        }
                        return
                    }

                    this.menuList = data
                    this.setLimitId()
                    if (!this.$route.params.id && !this.detailData.content) {
                        this.subCateClick(this.menuList[0].id)
                    }
                } catch (err) {
                    if (err.code === '-1') {
                        this.getAll = true
                    }
                    console.log(err)
                }
            },
            setLimitId () {
                const { menuList, getAll } = this
                this.limitId = {
                    start: menuList[0].id,
                    end: getAll ? menuList[menuList.length - 1].id : -1
                }
                if (getAll) {
                    return
                }

                const { id } = this.$route.params
                const hasCurrent = menuList.findIndex((e) => {
                    return e.id === id
                }) !== -1
                if (!hasCurrent) {
                    this.loadMore()
                }
            },
            async getArticle (newId) {
                try {
                    const { id } = this.$route.params
                    const data = await resourceArticleDetail({
                        service_code: this.webInfo.service_code,
                        type: 15,
                        id: newId || id,
                        user_unique_code: this.user_unique_code
                    })
                    this.detailData = data
                } catch (err) {
                    console.log(err)
                }
            },
            collect () {
                const { id: res_code } = this.$route.params
                const formData = {
                    type: 17,
                    res_code
                }
                const callback = (bool) => {
                    if (bool) {
                        this.detailData.follow_state = '2'
                    } else {
                        this.detailData.follow_state = '1'
                    }
                }
                this.$utils.userCollect(formData, callback)
            }
        },
        beforeRouteUpdate (to, from, next) {
            const { id } = to.params
            this.getArticle(id)
            const { contentBScrollObj } = this.$refs.textReading
            if (contentBScrollObj) {
                contentBScrollObj.finishPullUp()
                contentBScrollObj.scrollTo(0, 0)
            }
            next()
        },
        beforeRouteEnter: (to, from, next) => {
            next((vm) => {
                const { service_code } = vm.webInfo
                if (service_code) {
                    vm.getBookDetail()
                    vm.getCatelog()
                    vm.getQrcode()
                    const { id } = to.params
                    if (id) {
                        vm.getArticle(id)
                    }
                }
            })
        }
    }
</script>

<style scoped lang="less">
    .nav-wrap {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .subscribe-card-wrap {
        width: 300px;
        height: 136px;
        box-sizing: border-box;
        padding: 20px;
        background: #F5F7FA;
        border-radius: 8px 8px 0px 0px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .subscribe-card {
        width: 100%;
        height: 100%;
        flex-shrink: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .cover {
            width: 72px;
            height: 96px;
            box-sizing: border-box;
            border-radius: 4px;
            cursor: auto;
            margin-right: 10px;
        }

        .infos {
            height: 96px;
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-start;

            h4 {
                max-height: 48px;
                font-size: 18px;
                font-family: AlibabaPuHuiTiM;
                color: #303133;
                line-height: 24px;
                user-select: none;
                margin-bottom: 12px;
            }
        }
    }

    .subscribe-btn-wrap {
        width: 80px;
        height: 36px;
        overflow: hidden;
        background: #303133;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 18px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
    }

    .catelog-mask {
        width: 100%;
        flex: 1;
        overflow: hidden;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        h5 {
            padding: 10px 20px;
            margin-bottom: 15px;
            font-size: 16px;
            font-family: AlibabaPuHuiTiB;
            color: #303133;
            line-height: 16px;
            background: #FFFFFF;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            position: relative;

            &::before {
                content: "";
                display: block;
                width: 94px;
                height: 4px;
                background: #F0F2F5;
                position: absolute;
                top: 50%;
                left: -94px;
                margin-top: -2px;
            }

            &::after {
                content: "";
                display: block;
                width: 94px;
                height: 4px;
                background: #F0F2F5;
                position: absolute;
                top: 50%;
                right: -94px;
                margin-top: -2px;
            }
        }
    }

    .catelog-list {
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px 30px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .cate-item {
            width: 100%;
            padding: 10px 0;
            font-size: 14px;
            font-family: AlibabaPuHuiTiR;
            color: #606266;
            line-height: 20px;
            border-bottom: 1px solid #f1f1f1;
            cursor: pointer;
            user-select: none;

            &:first-child {
                padding-top: 0;
            }

            &:last-child {
                border-bottom: none;
            }

            &:hover {
                color: #303133;
            }
        }
    }
</style>
